<div class="ds-grid ds-grid--2">
	<!-- Standard Menu Buttons -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Standard Menu Buttons</h3>
			<p class="ds-example__header-subtitle">With different button variants</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-menu
					[text]="'Actions'"
					[postIcon]="'fa-solid fa-caret-down'"
					[menuItems]="actionsMenuItems"
					(menuItemClick)="onMenuClick($event)"
					[size]="'small'">
				</eif-custom-menu>
				<eif-custom-menu
					[text]="'Options'"
					[variant]="'outlined'"
					[postIcon]="'fa-solid fa-caret-down'"
					[menuItems]="advancedMenuItems"
					(menuItemClick)="onMenuClick($event)"
					[size]="'small'">
				</eif-custom-menu>
				<eif-custom-menu
					[text]="'More'"
					[variant]="'text'"
					[postIcon]="'fa-solid fa-caret-down'"
					[menuItems]="multipleMenuItems"
					(menuItemClick)="onMenuClick($event)"
					[size]="'small'">
				</eif-custom-menu>
			</div>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ lastAction || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Icon Menu Buttons -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Icon Menu Buttons</h3>
			<p class="ds-example__header-subtitle">Icon-only menu triggers</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-menu
					[color]="'neutral'"
					[variant]="'icon'"
					[preIcon]="'fa-solid fa-ellipsis-h'"
					[menuItems]="actionsMenuItems"
					(menuItemClick)="onMenuClick($event)">
				</eif-custom-menu>
				<eif-custom-menu
					[color]="'neutral'"
					[variant]="['icon', 'outlined']"
					[preIcon]="'fa-solid fa-ellipsis-v'"
					[menuItems]="advancedMenuItems"
					(menuItemClick)="onMenuClick($event)">
				</eif-custom-menu>
				<eif-custom-menu
					[color]="'neutral'"
					[variant]="['icon', 'text']"
					[preIcon]="'fa-solid fa-cog'"
					[menuItems]="multipleMenuItems"
					(menuItemClick)="onMenuClick($event)">
				</eif-custom-menu>
			</div>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ lastAction || 'No value' }}</div>
			</div>
		</div>
	</div>
</div>
